import axios from 'axios';
export const isProd = true;

const api = axios.create({
  baseURL: isProd ? 'https://api.oak-us.com/compliance/api' : 'http://localhost:5000/compliance/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

const authapi = axios.create({
  baseURL: isProd ? 'https://api.oak-us.com/api' : 'http://localhost:5000/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
}); 

export { api, authapi };